<template>
  <!-- <div> -->
  <v-row justify="center">
    <!-- <div v-for="(category, index) in categories" :key="index"> -->
    <v-dialog v-model="dialog" max-width="600px">
      <template v-slot:activator="{ on }">
        <v-btn
          @click.stop="dialog = true"
          large
          text
          outlined
          rounded
          class="ma-2"
          color="green darken-2"
          style="min-height: 70px; width: 80%"
        >
          <span class="subtitle-2" v-if="category === 'personalInformation'"
            >UPLOAD PERSONAL INFOMRATION DOCS</span
          >
          <span class="subtitle-2" v-if="category === 'generalInformation'"
            >UPLOAD GENERAL INFOMRATION DOCS</span
          >
          <span class="subtitle-2" v-if="category === 'damages'"
            >UPLOAD DAMAGES DOCS</span
          >
          <span class="subtitle-2" v-if="category === 'miscellaneous'"
            >UPLOAD MISCELLANEOUS DOCS</span
          >
          <v-icon>mdi-upload</v-icon>
        </v-btn>
      </template>
      <v-card
        class="ma-auto pa-2"
        flat
        filled
        style="
                  border-radius: 26px;
                  border: 1px solid #18CAE6;
                  max-width: 600px;
                  
                "
      >
        <v-card-title>
          <span
            class="headline"
            style="color: #18CAE6"
            v-if="category === 'personalInfomration'"
            >UPLOAD PERSONAL INFORMATION DOCUMENTS</span
          >
          <span
            class="headline"
            style="color: #18CAE6"
            v-if="category === 'generalInformation'"
            >UPLOAD GENERAL INFOMRATION DOCUMENTS</span
          >
          <span
            class="headline"
            style="color: #18CAE6"
            v-if="category === 'damages'"
            >UPLOAD DAMAGES DOCUMENTS</span
          >
          <span
            class="headline"
            style="color: #18CAE6"
            v-if="category === 'miscellaneous'"
            >UPLOAD MISCELLANEOUS DOCUMENTS</span
          >
        </v-card-title>
        <v-form class="ma-2 pa-2" @submit.prevent="onAddClientDocs" ref="form">
          <div>
            <v-card
              class="ma-auto pa-2"
              flat
              filled
              style="
                  border-radius: 26px;
                  border: 1px solid #18CAE6;
                  max-width: 600px;
                  
                "
            >
              <v-card-title>
                SELECT
                <span class="red--text">FILE</span>
              </v-card-title>
              <div class="ma-2 mt-2">
                <v-file-input
                  class="ma-2 mt-6"
                  autofocus
                  outlined
                  chips
                  multiple
                  label="SELECT ONE OR MORE DOCUMENTS FOR THIS CATEGORY"
                  ref="fileInput"
                  @change="onFilePicked"
                  dense
                  color="#2E5473"
                ></v-file-input>
              </div>
              <div class="ma-2 mt-2">
                <v-card-title
                  >ADD A DESCRIPTION TO THIS DOCUMENT SET</v-card-title
                >
                <v-textarea
                  label="Description"
                  v-model="description"
                  clearable
                  color="#2E5473"
                  outlined
                ></v-textarea>
              </div>
              <v-card>
                <ol class="ma-auto">
                  <li v-for="(file, index) in clientDocs" :key="index">
                    <v-layout>
                      <div class="ma-auto">{{ file.name }}</div>
                      <v-btn small text rounded @click="removeFile(index)">
                        <v-icon color="red">mdi-minus-circle</v-icon>
                      </v-btn>
                    </v-layout>
                  </li>
                </ol>
              </v-card>
            </v-card>
          </div>
          <v-layout row class="mt-2">
            <v-spacer></v-spacer>
            <v-btn rounded text outlined @click="cancelDialog">CANCEL</v-btn>
            <v-spacer></v-spacer>
            <v-btn
              rounded
              color="black"
              :disabled="!formIsValid"
              dark
              type="submit"
              >SUBMIT</v-btn
            >
            <v-spacer></v-spacer>
          </v-layout>
        </v-form>
      </v-card>
    </v-dialog>

    <!-- </div> -->
  </v-row>
</template>

<script>
/**
 *
 * this component appears within the SelectedDocForm
 * to allow the firm user to upload documents to go along with the form
 * that is being edited on the firm user side.
 * this component is the firm user's version of the same component that the
 * client receives in ClientForm
 * (the form that appears when the client clicks the link that the user has sent them)
 * the categories of the documents are determined by the form object located in the
 * collection clients/clientSlug/formList/formID (the form object is created when user sends a client a from)
 * SEE - SendClientForm component
 *
 */
import * as moment from "moment";
import * as firebase from "firebase";

export default {
  props: [
    "category",
    "firm_slug",
    "matter_slug",
    "client_slug",
    "client_user",
    "storage_path"
  ],
  data() {
    return {
      clientDocs: [],
      description: null,
      dialog: false
    };
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
    // matter() {
    //   return this.$store.getters.;
    // },
    formIsValid() {
      return this.clientDocs !== null;
    }
  },
  methods: {
    onFilePicked() {
      if (event.target.files) {
        const fileList = Array.from(event.target.files);
        fileList.forEach(file => {
          this.clientDocs.push(file);
        });
      }
    },

    removeFile(index) {
      this.clientDocs.splice(index, 1);
    },

    onAddClientDocs() {
      if (this.formIsValid) {
        //save to storage with category
        const clientDocuments = [];

        this.clientDocs.forEach(doc => {
          const docName = doc.name;
          const ref = firebase.storage().ref(
            `${this.storage_path}/${this.category}/${docName}`
            // `firm/${this.firm_slug}/matter/${this.matter_slug}/client/${this.client_slug}/${this.category}/${docName}`
            // `client/${this.firm_slug}/${this.matter_slug}/${this.client_slug}`
            // client/engstrom-lipscomb-and-lack/a-v-b-20190522/first-plaintiff-111-1111111/woolsey-fire-cases-jccp-5000-personal-claims/3jwecm2wUVYEX7reSTxo
          );
          ref
            .put(doc)
            .then(() => {
              console.log("clientDoc successfully stored");
              ref
                .getDownloadURL()
                .then(url => {
                  // if(client_form_type === "old") {
                  //   clientDocuments.push({
                  //     url,
                  //     name: doc.name,
                  //     category: this.category,
                  //     date: moment().format("LL"),
                  //     user: this.client_user,
                  //     description: this.description,
                  //     origin: this.storage_path,
                  //     matter: this.matter_slug,
                  //     addedByAdmin: true
                  //   });
                  // } else {
                  // "category", "firm_slug", "matter_slug", "client_slug", "client_user", "storage_path"
                  clientDocuments.push({
                    url,
                    name: doc.name,
                    category: this.category,
                    date: moment().format("LL"),
                    user: this.client_user,
                    description: this.description,
                    origin: this.storage_path,
                    matter: this.matter_slug,
                    addedByAdmin: true
                  });
                  // }
                })
                .then(() => {
                  this.description = null;
                  clientDocuments.forEach(doc => {
                    firebase
                      .firestore()
                      // .collection("firms")
                      // .doc(this.firm_slug)
                      .collection("matters")
                      .doc(this.matter_slug)
                      .collection("clients")
                      .doc(this.client_slug)
                      //experimental
                      .update({
                        clientDocs: firebase.firestore.FieldValue.arrayUnion(
                          doc
                        )
                      })
                      .then(() => {
                        this.$emit("admin-added-client-doc");
                      })
                      .catch(e => console.log(e));
                  });
                  // let payload = {
                  //   firm: this.$route.params.firm,
                  //   matter: this.$route.params.matter,
                  //   client: this.$route.params.id
                  // };
                  // this.$store.dispatch("autoLoginClient", payload);
                })
                .catch(e => console.log(e));
            })
            .catch(e => console.log(e));
        });
        this.clientDocs = [];
        // this.description = null;
        this.dialog = false;
      }
    },
    cancelDialog() {
      this.clientDocs = [];
      this.description = null;
      this.dialog = false;
    }
  },
  created() {
    console.log("this.$route.path", this.$route.path);
    let testDocObj = {
      // url,
      // name: doc.name,
      category: this.category,
      date: moment().format("LL"),
      user: this.client_user,
      description: this.description,
      origin: this.storage_path,
      matter: this.matter_slug,
      addedByAdmin: true
    };
    console.log("testDocObj", testDocObj);
  }
};
</script>

<style lang="scss" scoped></style>
